import _ from 'lodash';

import { IChartData } from './interfaces';

const getChartPoints = (chartData: Array<IChartData>): Array<number | null> => {
    return chartData.reduce<Array<number | null>>((memo, data) => {
        return [...memo, ...data.points.playerPoints];
    }, []);
};

export const isChartDataEqual = (
    chartData1: Array<IChartData>,
    chartData2: Array<IChartData>,
) => {
    const chartPoints1 = getChartPoints(chartData1);
    const chartPoints2 = getChartPoints(chartData2);

    return _.isEqual(chartPoints1, chartPoints2);
};
